import { CameraFlipIcon } from './CameraFlipIcon';

/**
 * author: Michael Irigoyen
 * id D4175840-8B51-4C1E-AFF2-A8142F5CCF2E
 * name camera-flip
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-flip.svg
 * tags
 * - Photography 
 */
export const CameraSyncIcon = CameraFlipIcon;
export default CameraSyncIcon